import { useState } from "react";
import { FiCopy, FiCheck, FiLink } from "react-icons/fi";
import { toast } from "react-toastify";

interface InviteLinkCardProps {
  inviteUrl: string;
}

export default function InviteLinkCard({ inviteUrl }: InviteLinkCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!inviteUrl) return;
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      toast.success("Link de cadastro copiado!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Não foi possível copiar o link.");
    }
  };

  return (
    <div
      className="mb-4 rounded-xl border border-purple-200 bg-gradient-to-r from-purple-50 to-pink-50 p-4 shadow-sm dark:border-purple-800/50 dark:from-purple-950/40 dark:to-pink-950/30 sm:mb-6 sm:p-5"
      data-testid="invite-link-card"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-purple-600 to-pink-600 text-white">
          <FiLink size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">
            Seu link de cadastro
          </h3>
          <p className="mt-0.5 text-sm text-gray-600 dark:text-gray-400">
            Compartilhe com seus alunos para eles se cadastrarem já vinculados a
            você.
          </p>
          <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center">
            <div
              className="min-w-0 flex-1 truncate rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
              data-testid="invite-link-url"
            >
              {inviteUrl || "Carregando..."}
            </div>
            <button
              type="button"
              onClick={handleCopy}
              disabled={!inviteUrl}
              data-testid="invite-link-copy"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {copied ? <FiCheck size={16} /> : <FiCopy size={16} />}
              {copied ? "Copiado" : "Copiar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
